import { Pipe, PipeTransform } from '@angular/core';
import { ResourceService } from 'sce-core';

@Pipe({
  name: 'translateResource'
})
export class TranslateResourcePipe implements PipeTransform {

  constructor(private resourceService: ResourceService) {}

  transform(key: string): string {
    if (!key) {
      return '';
    }
    return this.resourceService.get(key);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/pipes/translate-resource.pipe.ts